export const isMoneyGreaterThanZero = (value: string | number): boolean => {
    const regex = /^(?:0|\d+)?(?:\.\d{1,2})?$/;
    const stringValue = String(value);
    return regex.test(stringValue) && parseFloat(stringValue) > 0;
};

export const isMoneyGreaterThanZeroThreeDecimals = (value: string | number): boolean => {
    const regex = /^(?:0|\d+)?(?:\.\d{1,3})?$/;
    const stringValue = String(value);
    return regex.test(stringValue) && parseFloat(stringValue) > 0;
};

export const UNIT_COGS_POSITIVE_NUMBER_ERROR = 'Unit COGS must be a positive number';
export const UNIT_COGS_THREE_DECIMAL_ERROR = 'Unit COGS must be a positive number to 3 dp, e.g. 1.123';

export const getUnitCogsValidationError = (value: string | number): string => {
    if (isMoneyGreaterThanZeroThreeDecimals(value)) {
        return '';
    }

    const parsed = parseFloat(String(value).trim());
    if (!Number.isNaN(parsed) && parsed > 0) {
        return UNIT_COGS_THREE_DECIMAL_ERROR;
    }

    return UNIT_COGS_POSITIVE_NUMBER_ERROR;
};

export const isMoneyGreaterOrEqualToZero = (value: string | number): boolean => {
    const regex = /^(?:0|\d+)?(?:\.\d{1,2})?$/;
    const stringValue = String(value);
    return regex.test(stringValue) && parseFloat(stringValue) >= 0;
};

export function validateEndDate(startDate: string | Date | null | undefined, endDate: string | Date | null | undefined): boolean {
    if (endDate === null || endDate === undefined || endDate === "") return true;

    if (!startDate) return false;

    const start = new Date(startDate);
    const end = new Date(endDate);

    const oneWeekInMillis = 7 * 24 * 60 * 60 * 1000;
    const timeDifference = end.getTime() - start.getTime();

    return timeDifference > oneWeekInMillis && end > new Date();
}

export function validateStartDate(startDate: string | Date | null | undefined): boolean {
    if (!startDate) {
        return false;
    }

    const date = new Date(startDate);

    if (!(date instanceof Date) || isNaN(date.getTime())) {
        return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return date >= today;
}

export function validateString(input: unknown): boolean {
    if (typeof input !== 'string') {
        return false; // Not a string
    }

    const trimmedInput = input.trim();

    return trimmedInput.length !== 0;
}

export const isGreaterThanZero = (value: number): boolean => {
    return Number.isInteger(value) && value > 0;
};

export const isPositiveWholeNumber = (value: string | number): boolean => {
    if (typeof value === 'number') {
        return Number.isInteger(value) && value > 0;
    }

    const trimmed = value.trim();
    if (!/^\d+$/.test(trimmed)) {
        return false;
    }

    const parsed = Number(trimmed);
    return Number.isSafeInteger(parsed) && parsed > 0;
};

export const isGreaterOrEqualToZero = (value: string | number): boolean => {
    const intValue = parseInt(String(value), 10);

    return !isNaN(intValue) && intValue >= 0 && Number.isInteger(intValue);
};

export const isWholeNumber = (distribution: string | number): boolean => {
    const floatValue = parseFloat(String(distribution));
    return !isNaN(floatValue) && floatValue >= 0 && Number.isInteger(floatValue);
}; 